<template>
  <div class="bg-white rounded-lg shadow p-4 space-y-3">
    <div class="h-5 w-2/3 rounded bg-gray-200 animate-pulse"></div>
    <div v-for="row in 3" :key="row" class="grid grid-cols-3 gap-x-2">
      <div class="h-4 w-3/4 rounded bg-gray-200 animate-pulse"></div>
      <div class="col-span-2 h-4 rounded bg-gray-200 animate-pulse"></div>
    </div>
  </div>
</template>
